module.exports = __webpack_public_path__ + "static/media/cSilde1.4e92fdde.jpg";